<template>
  <v-container class="py-4">
    <dashboard-tiles
      :tilesData="tilesData"
      :contactInfo="contactInfo"
    />
    <v-row>
      <v-col class="lighten-4">
        <customer-engagement
          v-if="!infoLoader"
          :contactInfo="contactInfo"
          :dnm ="toggleDNMSwitch"
        />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { $metrics, $marketingContacts } from "@core/services"
import DashboardTiles from '../components/DashboardTiles.vue'
import CustomerEngagement from '../components/CustomerEngagement.vue'
import { mapGetters } from "vuex"

export default {
    name: "contact-dashboard-overview",
    components: {
      DashboardTiles,
      CustomerEngagement,
    },
    props: {
      contactInfo: {
        type: Object,
      },
      infoLoader: {
        type: Boolean
      },
      currentAccount: [Object],
      roles: [Array]
    },
    data() {
        return {
          tilesData: {
            response_rate: {
              mdiIcon: 'email-open',
              iconColor: '#FFBF4A',
              label: 'Response Rate',
              value: '--',
              dataFormat: '',
              subLabel: '',
              subValue: '',
              subDataFormat: '',
              loader: true,
              link: false,
              access: this.currentAccount.enable_marketing && this.roles.includes('contacts'),
            },
            best_time: {
              mdiIcon: 'clock-outline',
              iconColor: '#3D40C6',
              label: 'Ideal Response Time',
              value: '--',
              dataFormat: '',
              subLabel: '',
              subValue: '',
              subDataFormat: '',
              loader: true,
              link: false,
              access: this.currentAccount.enable_marketing && this.roles.includes('contacts'),
            },
            total_spent: {
              mdiIcon: 'currency-usd',
              iconColor: '#67D884',
              label: 'Lifetime Value',
              value: '--',
              dataFormat: 'currency',
              subLabel: 'vs. average',
              subValue: '',
              subDataFormat: 'currency',
              loader: true,
              link: false,
              visibility:true,
              access: true
            },
            total_orders: {
              mdiIcon: 'cart',
              iconColor: '#F53BAD',
              label: 'Number of Orders',
              value: '--',
              dataFormat: '',
              subLabel: 'vs. average',
              subValue: '',
              subDataFormat: '',
              loader: true,
              link: true,
              visibility:true,
              access: true,
            },
            totalTickets: {
              mdiIcon: 'ticket-outline',
              iconColor: '#006BAF',
              label: 'Total Tickets',
              value: '--',
              dataFormat: '',
              subLabel: '',
              subValue: '',
              subDataFormat: '',
              loader: true,
              link: false,
              access: this.currentAccount.enable_service && this.$can('read','contacts'),
            },
            openTickets: {
              mdiIcon: 'ticket-confirmation',
              iconColor: '#03B6FC',
              label: 'Open Tickets',
              value: '--',
              dataFormat: '',
              subLabel: '',
              subValue: '',
              subDataFormat: '',
              loader: true,
              link: false,
              access: this.currentAccount.enable_service && this.$can('read','contacts'),
            },
            solved: {
              mdiIcon: 'marker-check',
              iconColor: '#41CE65',
              label: 'Solved Tickets',
              value: '--',
              dataFormat: '',
              subLabel: '',
              subValue: '',
              subDataFormat: '',
              loader: true,
              link: false,
              access: this.currentAccount.enable_service && this.$can('read','contacts'),
            },
            onHold: {
              mdiIcon: 'hand-back-left',
              iconColor: '#B00020',
              label: 'On-hold Tickets',
              value: '--',
              dataFormat: '',
              subLabel: '',
              subValue: '',
              subDataFormat: '',
              loader: true,
              link: false,
              access: this.currentAccount.enable_service && this.$can('read','contacts'),
            },
          },
          toggleDNMSwitch: false,
          totalCampaings: 0,
          totalAbCarts: 0,
        };
    },
    computed: {
    ...mapGetters({
       userAccess : 'auth/userAccess'
    }),
  },
    watch: {
      contactInfo () {
        if (this.contactInfo.email) {
          if (
            this.currentAccount.enable_marketing
            && this.roles.includes('contacts')
          ) {
            this.fetchMarketingMetrics('best_time')
            this.fetchMarketingMetrics('total_spent')
            this.fetchMarketingMetrics('total_orders')
            this.fetchMarketingMetrics('response_rate')
            this.fetchMarketingMetrics('total_campaigns')
            this.fetchMarketingMetrics('total_ab_carts')
          }
          if (this.currentAccount.enable_service) {
            this.fetchServiceMetrics()
            this.fetchMarketingMetrics('total_spent')
            this.fetchMarketingMetrics('total_orders')
          }
        }
      }
    },
    mounted() {
    },
    methods: {
      fetchMarketingMetrics (type) {
        if (type !== 'total_campaigns' && type !== 'total_ab_carts'){
          this.tilesData[type].loader = true
        }
        const payload = {
          params: {
            'contact[email]': this.contactInfo.email
          }
        }
        $marketingContacts.stat(this.contactInfo.id, type, payload).then(response => {
          if (type !== 'total_campaigns' && type !== 'total_ab_carts'){
            const dataValue = Object.values(response.data)[0]
            this.tilesData[Object.keys(response.data)[0]].value = (dataValue !== null && dataValue !== 0) ? dataValue : '--'
            if (type === 'total_spent') {
              this.tilesData.total_spent.subValue = response.data.average_spent || this.tilesData.total_spent.subValue
            }
            if (type === 'total_orders') {
              this.tilesData.total_orders.subValue = `${response.data.average_orders} Orders` || response.data.total_orders
            }
          }
          if (type === 'total_campaigns') {
            this.totalCampaings = response.data.data.count
          }
          if (type === 'total_ab_carts') {
            this.totalAbCarts = response.data.data.count
          }
          this.sendDataToParent()
        }).finally( () => {
          if (type !== 'total_campaigns' && type !== 'total_ab_carts'){
            this.tilesData[type].loader = false
          }
        })
      },
      fetchServiceMetrics () {
        this.tilesData.totalTickets.loader = true
        this.tilesData.openTickets.loader = true
        this.tilesData.solved.loader = true
        this.tilesData.onHold.loader = true
        this.tilesData.total_spent.loader = true
        this.tilesData.total_orders.loader = true
        const payload = {
          contact_email: this.contactInfo.email,
        }
        $metrics.fetch({ params: payload }).then(response => {
          const result = response.data
          let totalTicket = 0
          if (result.closed) {
            totalTicket += result.closed
          }
          if (result.unresolved) {
            totalTicket += result.unresolved
          }
          this.tilesData.totalTickets.value = totalTicket ? totalTicket : '--'
          this.tilesData.openTickets.value = result.open ? result.open : '--'
          this.tilesData.solved.value = result.closed ? result.closed : '--'
          this.tilesData.onHold.value = result.on_hold ? result.on_hold : '--'
          this.sendDataToParent()
        }).finally(() => {
          this.tilesData.totalTickets.loader = false
          this.tilesData.openTickets.loader = false
          this.tilesData.solved.loader = false
          this.tilesData.onHold.loader = false
          this.tilesData.total_spent.loader = false 
          this.tilesData.total_orders.loader= false
        })
      },
      sendDataToParent () {
        // fetch total campaing here
        const dataToSend = {
          count: {
            tickets: this.tilesData.totalTickets ? this.tilesData.totalTickets.value : 0,
            orders: this.tilesData.total_orders ? this.tilesData.total_orders.value : 0,
            campaigns: this.totalCampaings,
            abCarts: this.totalAbCarts,
          }
        }
        this.$emit('countEvent', dataToSend);
      }
    },
};
</script>
<style lang="scss" scoped>
</style>